import React from "react";

// Supports two modes:
// stats=[{label, value}]  — old number-based bar
// tiles=[{icon, headline, subtext}]  — new value-proposition tiles
export default function SocialProofBar({ stats = [], tiles = [] }) {
  if (tiles.length > 0) {
    return (
      <div className="w-full py-16 relative overflow-hidden" style={{ background: "#080808" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {tiles.map((tile, i) => (
              <div
                key={i}
                style={{
                  background: "#111111",
                  border: "1px solid rgba(249,115,22,0.15)",
                  borderLeft: "3px solid #F97316",
                  borderRadius: 12,
                  padding: "24px 22px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                <span style={{ fontSize: "1.6rem", lineHeight: 1 }}>{tile.icon}</span>
                <p style={{ fontSize: "0.95rem", fontWeight: 700, color: "#FFFFFF", lineHeight: 1.3, margin: 0 }}>
                  {tile.headline}
                </p>
                <p style={{ fontSize: "0.82rem", color: "#D1D5DB", lineHeight: 1.55, margin: 0 }}>
                  {tile.subtext}
                </p>
              </div>
            ))}
          </div>
        </div>
        <hr style={{ borderColor: "rgba(245,245,245,0.06)", marginTop: "4rem" }} />
      </div>
    );
  }

  if (!stats || stats.length === 0) return null;

  return (
    <div className="w-full py-16 relative overflow-hidden" style={{ background: "#080808" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {stats.map((stat, i) => (
            <div key={i} className="text-center">
              <p
                className="text-sm font-medium mb-2 tracking-wide"
                style={{ color: "#F97316", textTransform: "uppercase" }}
              >
                ✓ {stat.label}
              </p>
              <p className="text-base" style={{ color: "rgba(245,245,245,0.5)" }}>
                {stat.value}
              </p>
            </div>
          ))}
        </div>
      </div>
      <hr style={{ borderColor: "rgba(245,245,245,0.06)", marginTop: "4rem" }} />
    </div>
  );
}
